const getPluginsSupport = (): boolean => {
    return navigator.plugins !== undefined
}

export default getPluginsSupport;